import React from "react"
import * as Yup from "yup"
import { useFormik } from "formik"
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  FormFeedback,
  Label,
  Form,
} from "reactstrap"

//redux
import { useDispatch } from "react-redux"

import { createMDMCountry, updateMDMCountry } from "store/actions"
import { withTranslation } from "react-i18next"

const CountryModal = props => {
  const { modal, toggle, country, isEdit } = props
  const dispatch = useDispatch()
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameEn: (country && country.nameEn) || "",
      nameFr: (country && country.nameFr) || "",
      nameAr: (country && country.nameAr) || "",
      iso_code: (country && country.iso_code) || "",
      type: (country && country.type) || "country",
      status: "active" || null,
    },
    validationSchema: Yup.object({
      nameEn: Yup.string().required(props.t("Please Enter Your English name")),
      // nameFr: Yup.string().required(props.t("Please Enter Your French name")),
      // nameAr: Yup.string().required(props.t("Please Enter Your Arabic Name")),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateCountry = {
          id: country ? country.id : 0,
          nameEn: values.nameEn,
          nameFr: values.nameFr,
          nameAr: values.nameAr,
          iso_code: values.iso_code,
          status: "active",
        }
        // update
        // console.log("updatecity", updateCountry)
        dispatch(updateMDMCountry(updateCountry))
        validation.resetForm()
      } else {
        const newCountry = {
          nameEn: values["nameEn"],
          nameFr: values["nameFr"],
          nameAr: values["nameAr"],
          type: values["type"],
          iso_code: values["iso_code"],
          status: "active",
        }
        // save new country
        dispatch(createMDMCountry(newCountry))
        validation.resetForm()
      }
      toggle()
    },
  })
  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle} tag="h4">
        {!!isEdit ? props.t("Edit Country") : props.t("Add Country")}
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row form>
            <Col className="col-12">
              <div className="mb-3">
                <Label className="form-label">{props.t("Name")}</Label>
                <Input
                  name="nameEn"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.nameEn || ""}
                  invalid={
                    validation.touched.nameEn && validation.errors.nameEn
                      ? true
                      : false
                  }
                />
                {validation.touched.nameEn && validation.errors.nameEn ? (
                  <FormFeedback type="invalid">
                    {validation.errors.nameEn}
                  </FormFeedback>
                ) : null}
              </div>
              <div className="mb-3">
                <Label className="form-label">{props.t("iso code")}</Label>
                <Input
                  name="iso_code"
                  type="text"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.iso_code || ""}
                  invalid={
                    validation.touched.iso_code && validation.errors.iso_code
                      ? true
                      : false
                  }
                />
                {validation.touched.iso_code && validation.errors.iso_code ? (
                  <FormFeedback type="invalid">
                    {validation.errors.iso_code}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-end">
                <button type="submit" className="btn btn-success save-customer">
                  {props.t("Save")}
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

export default withTranslation()(CountryModal)
